module.exports = __webpack_public_path__ + "static/media/IMG_0094.133a228a.jpg";